import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import { baseurl, baseurImage } from "../../Baseurl";
import {
  fetchModuleMappings,
  hasSubModulePermission,
  isAdmin,
} from "../../utils/permissions";
import axiosInstance from "../../api/axiosInstance";

export default function ManageLabs() {
  const navigate = useNavigate();
  const [labRequests, setLabRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTab, setSelectedTab] = useState("Not Sent");
  const [labs, setLabs] = useState([]);
  const [labServices, setLabServices] = useState([]);
  const [refreshFlag, setRefreshFlag] = useState(0);
  const [showReportModal, setShowReportModal] = useState(false);
  const [reportLabId, setReportLabId] = useState(null);
  const [reportFiles, setReportFiles] = useState([]);
  const [loggedInUserName, setLoggedInUserName] = useState("");
  const [reportName, setReportName] = useState("");
  const [reportStatus, setReportStatus] = useState("");
  const [reportLabTests, setReportLabTests] = useState([]);
  const [reportTestValues, setReportTestValues] = useState({});
  const [autoFilledTestIds, setAutoFilledTestIds] = useState(new Set());
  const [parsingPdf, setParsingPdf] = useState(false);
  const [importedPdfFile, setImportedPdfFile] = useState(null);
  const importedPdfInputRef = useRef(null);
  const [editLabTests, setEditLabTests] = useState([]);
  const [editTestValues, setEditTestValues] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({
    request_id: null,
    lab_id: "",
    title: "",
    description: "",
    serviceIds: [],
    discount_type: "Amount",
    discount_value: "",
    attachmentName: "",
    newAttachment: null,
  });
  const [editAttachments, setEditAttachments] = useState([]);
  const [showViewAttachmentsModal, setShowViewAttachmentsModal] =
    useState(false);
  const [viewAttachments, setViewAttachments] = useState([]);
  const [selectedLabRequest, setSelectedLabRequest] = useState(null);
  const [editLabName, setEditLabName] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  const [searchLab, setSearchLab] = useState("");
  const [recordLockHours, setRecordLockHours] = useState(null);

  // WhatsApp default notification template for the Lab module
  const [showWhatsappModal, setShowWhatsappModal] = useState(false);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [loadingSmsTemplates, setLoadingSmsTemplates] = useState(false);
  const [selectedWhatsappTemplate, setSelectedWhatsappTemplate] = useState("");
  const [savingWhatsappTemplate, setSavingWhatsappTemplate] = useState(false);

  const [permissions, setPermissions] = useState({
    newRequest: false,
    labs: false,
    labServices: false,
  });

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("userMedical"));
      const name = userData?.data?.fullName || userData?.fullName || "";
      setLoggedInUserName(name);
    } catch {
      setLoggedInUserName("");
    }
  }, []);

  useEffect(() => {
    const checkPermissions = async () => {
      if (isAdmin()) {
        setPermissions({ newRequest: true, labs: true, labServices: true });
        return;
      }

      try {
        const allModules = await fetchModuleMappings();
        const labModule = allModules.find(
          (m) => m.module_name.toLowerCase() === "labs"
        );

        if (labModule && labModule.sub_modules) {
          // Find exact submodule names from database
          const labSub = labModule.sub_modules.find(
            (sm) => sm.sub_module_name === "lab"
          );
          const labServicesSub = labModule.sub_modules.find(
            (sm) => sm.sub_module_name === "lab_services"
          );
          const labNewRequestSub = labModule.sub_modules.find(
            (sm) => sm.sub_module_name === "lab_new_request"
          );

          setPermissions({
            labs: labSub ? hasSubModulePermission(labSub.id) : false,
            labServices: labServicesSub
              ? hasSubModulePermission(labServicesSub.id)
              : false,
            newRequest: labNewRequestSub
              ? hasSubModulePermission(labNewRequestSub.id)
              : false,
          });
        }
      } catch (err) {
        console.error("Error checking permissions", err);
      }
    };

    checkPermissions();
  }, []);

  useEffect(() => {
    setLoading(true);
    setError(null);
    axiosInstance
      .post(`getLabRequestsByStatus`, { status: selectedTab })
      .then((res) => {
        if (res.data.success && Array.isArray(res.data.data)) {
          setLabRequests(res.data.data);
        } else {
          setLabRequests([]);
        }
        setLoading(false);
      })
      .catch((err) => {
        setError("Failed to fetch lab requests");
        setLoading(false);
      });
  }, [selectedTab, refreshFlag]);

  useEffect(() => {
    axiosInstance
      .get("getBusinessSettings")
      .then((res) => {
        const h = res.data?.data?.record_lock_hours;
        if (h != null) setRecordLockHours(Number(h));
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    axiosInstance.get(`getAllLabs`).then((res) => {
      if (res.data.success && Array.isArray(res.data.data)) {
        setLabs(res.data.data);
      }
    });
  }, []);

  const fetchServicesForLab = async (labId, existingServiceIds = null) => {
    if (!labId) {
      setLabServices([]);
      return;
    }

    try {
      const res = await axiosInstance.get(`getLabById/${labId}`);
      if (
        res.data.success &&
        res.data.data &&
        Array.isArray(res.data.data.services)
      ) {
        const services = res.data.data.services;
        setLabServices(services);

        if (existingServiceIds && existingServiceIds.length > 0) {
          const idStrs = existingServiceIds.map((id) => String(id));
          // Check both 'id' and 'service_id' in services array
          const found = services.filter(
            (s) =>
              idStrs.includes(String(s.id)) ||
              idStrs.includes(String(s.service_id))
          );

          if (found.length > 0) {
            setEditData((prev) => ({
              ...prev,
              serviceIds: found.map((s) => String(s.id || s.service_id)),
            }));
          }
        }
      } else {
        setLabServices([]);
      }
    } catch (error) {
      console.error("Failed to fetch lab services", error);
      setLabServices([]);
    }
  };

  // Fetch and merge (deduped by test id) the lab tests linked to a set of service ids
  const fetchMergedLabTests = async (serviceIds) => {
    const uniqueIds = [...new Set((serviceIds || []).filter(Boolean).map(String))];
    if (uniqueIds.length === 0) return [];
    const results = await Promise.all(
      uniqueIds.map((id) => axiosInstance.get(`getLabServiceTests/${id}`))
    );
    const merged = new Map();
    results.forEach((res) => {
      (res.data?.data || []).forEach((test) => {
        if (!merged.has(test.id)) merged.set(test.id, test);
      });
    });
    return Array.from(merged.values());
  };

  const loadLabRequestDetails = async (requestId, labIdFromRow) => {
    try {
      const res = await axiosInstance.get(`getLabRequestById/${requestId}`);
      if (res.data.success && res.data.data) {
        const data = res.data.data;

        let serviceId = "";
        if (data.serviceId) {
          serviceId = String(data.serviceId);
        } else if (data.service_id) {
          serviceId = String(data.service_id);
        } else if (typeof data.services_id === "string") {
          try {
            const parsed = JSON.parse(data.services_id);
            if (Array.isArray(parsed) && parsed.length > 0) {
              serviceId = String(parsed[0]);
            }
          } catch (e) {
            console.error("Error parsing services_id", e);
          }
        }

        const labIdToUse = data.lab_id || labIdFromRow;

        setEditData((prev) => ({
          ...prev,
          lab_id: labIdToUse ? String(labIdToUse) : prev.lab_id,
          serviceId: serviceId,
        }));

        if (labIdToUse) {
          fetchServicesForLab(labIdToUse, serviceId);
        }
      }
    } catch (error) {
      console.error("Failed to load lab request details", error);
    }
  };

  const filteredLabRequests = labRequests.filter((item) => {
    const q = searchLab.toLowerCase().trim();
    if (!q) return true;
    return (
      (item.patient_name && item.patient_name.toLowerCase().includes(q)) ||
      (item.lab_name && item.lab_name.toLowerCase().includes(q)) ||
      (item.title && item.title.toLowerCase().includes(q)) ||
      (item.description && item.description.toLowerCase().includes(q)) ||
      (item.patient_civil_id && item.patient_civil_id.toLowerCase().includes(q)) ||
      (item.mobileNumber && item.mobileNumber.toLowerCase().includes(q)) ||
      (item.request_id && String(item.request_id).toLowerCase().includes(q)) ||
      (item.request_date && item.request_date.toLowerCase().includes(q))
    );
  });

  const totalPages = Math.ceil(filteredLabRequests.length / itemsPerPage);
  const paginatedLabRequests = filteredLabRequests.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [selectedTab, searchLab]);

  const handleDelete = (request_id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this request!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        axiosInstance
          .delete(`deleteLabRequest/${request_id}`)
          .then((res) => {
            if (res.data.success) {
              setLabRequests((prev) =>
                prev.filter((item) => item.request_id !== request_id)
              );
              Swal.fire("Deleted!", "The request has been deleted.", "success");
            } else {
              Swal.fire(
                "Error",
                res.data.message || "Failed to delete request",
                "error"
              );
            }
          })
          .catch(() => {
            Swal.fire("Error", "Server error while deleting request", "error");
          });
      }
    });
  };

  const isLabRequestLocked = (lab) => {
    const dateStr = lab.request_date || lab.pending_at || lab.received_at;
    return recordLockHours && dateStr
      ? Date.now() - new Date(dateStr).getTime() > recordLockHours * 60 * 60 * 1000
      : false;
  };

  const handleStatusChange = async (requestId, newStatus) => {
    try {
      const res = await axiosInstance.put(
        `updateLabRequestStatus/${requestId}`,
        { status: newStatus }
      );
      if (res.data.success) {
        setRefreshFlag((f) => f + 1);
        Swal.fire("Success", "Status updated successfully", "success");
      } else {
        Swal.fire(
          "Error",
          res.data.message || "Failed to update status",
          "error"
        );
      }
    } catch {
      Swal.fire("Error", "Server error while updating status", "error");
    }
  };

  const handleAddReportClick = async (lab) => {
    setReportLabId(lab.request_id);
    setShowReportModal(true);
    setReportFiles([]);
    setReportName("");
    setReportStatus("");
    setReportLabTests([]);
    setReportTestValues({});
    setAutoFilledTestIds(new Set());
    setImportedPdfFile(null);

    // Determine all service IDs linked to this request
    const serviceIds = lab.services && lab.services.length > 0
      ? lab.services.map((s) => s.id || s.serviceId).filter(Boolean)
      : [lab.service_id || lab.serviceId].filter(Boolean);
    if (serviceIds.length > 0) {
      try {
        const [mergedTests, valuesRes] = await Promise.all([
          fetchMergedLabTests(serviceIds),
          axiosInstance.get(`getLabReportValues/${lab.request_id}`),
        ]);
        setReportLabTests(mergedTests);
        const valuesMap = {};
        (valuesRes.data.data || []).forEach((v) => {
          valuesMap[v.lab_test_id] = v.value !== null ? String(v.value) : "";
        });
        setReportTestValues(valuesMap);
      } catch (err) {
        console.error("Error loading lab tests for report:", err);
      }
    }
  };

  // Helper: determine if a value is normal / below / above range
  const getTestStatus = (value, minRange, maxRange) => {
    if (value === "" || value === null || value === undefined) return null;
    const v = parseFloat(value);
    if (isNaN(v)) return null;
    const min = minRange !== null && minRange !== undefined ? parseFloat(minRange) : null;
    const max = maxRange !== null && maxRange !== undefined ? parseFloat(maxRange) : null;
    if (min === null && max === null) return "no-range";
    if (min !== null && v < min) return "below";
    if (max !== null && v > max) return "above";
    return "normal";
  };

  const statusBadgeStyle = {
    normal:   { background: "#d4edda", color: "#155724" },
    below:    { background: "#cce5ff", color: "#004085" },
    above:    { background: "#f8d7da", color: "#721c24" },
    "no-range": { background: "#e2e3e5", color: "#383d41" },
  };

  const statusLabel = { normal: "Normal", below: "Below", above: "Above", "no-range": "—" };

  const labelStyle = { fontSize: 11, fontWeight: 700, color: "#5B6B79", textTransform: "uppercase", letterSpacing: "0.4px", display: "block", marginBottom: 4 };
  const inputStyle = { fontSize: 13, borderRadius: 8, border: "1px solid #dde3eb" };

  const handleGenerateReport = async (lab) => {
    try {
      const [logoRes, valuesRes] = await Promise.all([
        axiosInstance.get("getLogo"),
        axiosInstance.get(`getLabReportValues/${lab.request_id}`),
      ]);

      const logoDataUrl = logoRes.data?.success ? logoRes.data.logo : null;
      const testValues = valuesRes.data?.success ? (valuesRes.data.data || []) : [];

      const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
      const pageWidth = doc.internal.pageSize.getWidth();
      const margin = 14;
      const contentWidth = pageWidth - margin * 2;
      let y = 15;

      const fmtDate = (val) => {
        if (!val) return "—";
        return new Date(val).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
      };

      // ── Logo ──
      if (logoDataUrl) {
        try {
          const mimeMatch = logoDataUrl.match(/^data:image\/(\w+);base64,/);
          const imgFormat = mimeMatch ? mimeMatch[1].toUpperCase().replace("JPG", "JPEG") : "PNG";
          const imgProps = doc.getImageProperties(logoDataUrl);
          const maxW = 50;
          const maxH = 25;
          const ratio = Math.min(maxW / imgProps.width, maxH / imgProps.height);
          const imgW = imgProps.width * ratio;
          const imgH = imgProps.height * ratio;
          doc.addImage(logoDataUrl, imgFormat, (pageWidth - imgW) / 2, y, imgW, imgH);
          y += imgH + 5;
        } catch (imgErr) {
          console.warn("Logo render failed:", imgErr);
        }
      }

      // ── Title ──
      doc.setDrawColor(0);
      doc.setLineWidth(0.5);
      doc.line(margin, y, pageWidth - margin, y);
      y += 6;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(13);
      doc.setTextColor(0);
      doc.text("LAB TEST REPORT", pageWidth / 2, y, { align: "center" });
      y += 3;
      doc.line(margin, y, pageWidth - margin, y);
      y += 7;

      // ── Patient Info (two-column layout) ──
      doc.setFontSize(9.5);
      const col1x = margin;
      const col2x = pageWidth / 2 + 5;
      const labelW = 38;

      const infoLeft = [
        ["Patient Name", lab.patient_name || "—"],
        ["Age / Gender", [lab.age ? `${lab.age} yrs` : null, lab.gender].filter(Boolean).join(" / ") || "—"],
        ["CPR (Civil ID)", lab.patient_civil_id || "—"],
      ];
      const infoRight = [
        ["Sample Collected At", lab.lab_name || "—"],
      ];

      const infoRowCount = Math.max(infoLeft.length, infoRight.length);
      for (let i = 0; i < infoRowCount; i++) {
        let rowHeight = 6;
        if (infoLeft[i]) {
          const [label, value] = infoLeft[i];
          doc.setFont("helvetica", "bold");
          doc.text(`${label}:`, col1x, y);
          doc.setFont("helvetica", "normal");
          if (label === "Patient Name" && value.length > 20) {
            const lines = [];
            for (let s = 0; s < value.length; s += 20) lines.push(value.slice(s, s + 20));
            doc.text(lines, col1x + labelW, y);
            rowHeight = Math.max(rowHeight, 6 + (lines.length - 1) * 5);
          } else {
            doc.text(value, col1x + labelW, y);
          }
        }
        if (infoRight[i]) {
          doc.setFont("helvetica", "bold");
          doc.text(`${infoRight[i][0]}:`, col2x, y);
          doc.setFont("helvetica", "normal");
          doc.text(infoRight[i][1], col2x + labelW, y);
        }
        y += rowHeight;
      }
      y += 4;

      // ── Lab Test Results Table ──
      doc.setFont("helvetica", "bold");
      doc.setFontSize(10);
      doc.text("Test Results", margin, y);
      y += 4;

      if (testValues.length > 0) {
        const tableBody = testValues.map((row) => {
          const isText = row.value_type === "text";
          const status = isText ? null : getTestStatus(row.value, row.min_range, row.max_range);
          const isAbnormal = status === "above" || status === "below";
          let valStr;
          if (isText) {
            valStr = row.value !== null && row.value !== undefined && row.value !== "" ? String(row.value) : "—";
          } else {
            valStr = row.value !== null && row.value !== undefined && row.value !== "" ? parseFloat(row.value).toFixed(2) : "—";
          }
          let refRange;
          if (isText) {
            refRange = row.reference_text || "—";
          } else {
            const minStr = row.min_range !== null && row.min_range !== undefined ? parseFloat(row.min_range).toFixed(2) : "—";
            const maxStr = row.max_range !== null && row.max_range !== undefined ? parseFloat(row.max_range).toFixed(2) : "—";
            refRange = (minStr !== "—" || maxStr !== "—") ? `${minStr} – ${maxStr}` : "—";
          }
          return {
            cells: [row.test_name, valStr, row.units || "—", refRange, row.methodology || "—"],
            isAbnormal,
            status,
            isText,
          };
        });

        // total content width = 182mm; column widths must sum to 182
        autoTable(doc, {
          startY: y,
          tableWidth: contentWidth,
          margin: { left: margin, right: margin },
          head: [["Test Name", "Value", "Units", "Ref. Range", "Methodology"]],
          body: tableBody.map((r) => r.cells),
          styles: {
            fontSize: 9,
            cellPadding: { top: 2.5, bottom: 2.5, left: 3, right: 3 },
            textColor: [0, 0, 0],
            lineColor: [0, 0, 0],
            lineWidth: 0.2,
            fillColor: [255, 255, 255],
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.3,
            lineColor: [0, 0, 0],
          },
          alternateRowStyles: { fillColor: [248, 248, 248] },
          columnStyles: {
            0: { cellWidth: 55 },
            1: { cellWidth: 22, halign: "center" },
            2: { cellWidth: 20, halign: "center" },
            3: { cellWidth: 35, halign: "center" },
            4: { cellWidth: 50 },
          },
          didParseCell: (data) => {
            if (data.section === "body") {
              const row = tableBody[data.row.index];
              if (row.isAbnormal) {
                data.cell.styles.fontStyle = "bold";
              }
            }
          },
        });
        y = (doc.lastAutoTable?.finalY ?? y) + 8;
      } else {
        doc.setFont("helvetica", "italic");
        doc.setFontSize(9.5);
        doc.setTextColor(80);
        doc.text("No lab test results recorded.", margin, y);
        doc.setTextColor(0);
        y += 10;
      }

      // ── Sample Dates ──
      doc.setDrawColor(0);
      doc.setLineWidth(0.2);
      doc.line(margin, y, pageWidth - margin, y);
      y += 5;

      const sampleDates = [
        ["Sample Collected On", fmtDate(lab.request_date)],
        ["Sample Received On",  fmtDate(lab.pending_at)],
        ["Sample Released On",  fmtDate(lab.received_at)],
      ];
      doc.setFontSize(9);
      const dateColW = contentWidth / 3;
      sampleDates.forEach(([label, val], i) => {
        const x = margin + i * dateColW;
        doc.setFont("helvetica", "bold");
        doc.text(label, x, y);
        doc.setFont("helvetica", "normal");
        doc.text(val, x, y + 5);
      });
      y += 14;

      // ── Footer ──
      doc.setDrawColor(0);
      doc.setLineWidth(0.3);
      doc.line(margin, y, pageWidth - margin, y);
      y += 5;
      doc.setFont("helvetica", "normal");
      doc.setFontSize(8.5);
      doc.setTextColor(80);
      const now = new Date().toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
      doc.text(`Generated: ${now}`, margin, y);
      if (lab.result_added_by) {
        doc.setFont("helvetica", "bold");
        doc.text(`Done By: ${lab.result_added_by}`, pageWidth - margin, y, { align: "right" });
      }

      // ── Open in new tab ──
      const pdfBlob = doc.output("blob");
      const blobUrl = URL.createObjectURL(pdfBlob);
      window.open(blobUrl, "_blank");
    } catch (err) {
      console.error("Generate report error:", err);
      Swal.fire("Error", "Failed to generate report. Please try again.", "error");
    }
  };

  // Update handleEditClick to fetch full details (Matches ManageAppointment pattern)
  const handleEditClick = async (lab) => {
    // 1. Open modal and set initial names immediately for UI responsiveness
    setShowEditModal(true);
    setEditLabName(lab.lab_name || "");

    // 2. Initialize editData with known values from the row object
    setEditData({
      request_id: lab.request_id,
      lab_id: lab.lab_id ? String(lab.lab_id) : "",
      title: lab.title || lab.Title || "",
      description: lab.description || "",
      serviceIds: [], // To be populated from details
      serviceQuantities: {}, // serviceId -> quantity, populated from details
      discount_type: lab.discount_type || "Amount",
      discount_value: lab.discount_value || "",
      attachmentName: "",
      newAttachment: null,
    });

    try {
      // 3. Fetch full details from API to get correct service ID(s)
      const res = await axiosInstance.get(`getLabRequestById/${lab.request_id}`);
      if (res.data.success && res.data.data) {
        const detailData = res.data.data;

        // Extract all service IDs linked to this request
        let extractedServiceIds = [];

        let extractedServiceQuantities = {};

        if (detailData.services && Array.isArray(detailData.services) && detailData.services.length > 0) {
          extractedServiceIds = detailData.services
            .map((s) => s.serviceId || s.id || s.service_id)
            .filter(Boolean);
          detailData.services.forEach((s) => {
            const sid = s.serviceId || s.id || s.service_id;
            if (sid) extractedServiceQuantities[sid] = Number(s.quantity) > 0 ? Number(s.quantity) : 1;
          });
        } else if (detailData.services_id) {
          try {
            const parsed = JSON.parse(detailData.services_id);
            if (Array.isArray(parsed)) {
              extractedServiceIds = parsed;
            }
          } catch (e) {
            // Not JSON - try CSV
            extractedServiceIds = String(detailData.services_id)
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);
          }
        } else if (detailData.serviceId) {
          extractedServiceIds = [detailData.serviceId];
        } else if (detailData.service_id) {
          extractedServiceIds = [detailData.service_id];
        }

        const effectiveLabId = detailData.lab_id || lab.lab_id;

        // Update edit data from detailed response
        setEditData((prev) => ({
          ...prev,
          lab_id: effectiveLabId ? String(effectiveLabId) : prev.lab_id,
          title: detailData.title || detailData.Title || prev.title,
          description: detailData.description || prev.description,
          discount_type: detailData.discount_type || prev.discount_type,
          discount_value: detailData.discount_value || prev.discount_value,
          serviceQuantities: extractedServiceQuantities,
        }));

        // 4. Load lab services and pre-select the matched services
        if (effectiveLabId) {
          await fetchServicesForLab(effectiveLabId, extractedServiceIds);
        }

        // 5. Load linked lab tests (merged across all services) + existing report values
        if (extractedServiceIds.length > 0) {
          try {
            const [mergedTests, valuesRes] = await Promise.all([
              fetchMergedLabTests(extractedServiceIds),
              axiosInstance.get(`getLabReportValues/${lab.request_id}`),
            ]);
            setEditLabTests(mergedTests);
            const valuesMap = {};
            (valuesRes.data.data || []).forEach((v) => {
              valuesMap[v.lab_test_id] = v.value !== null ? String(v.value) : "";
            });
            setEditTestValues(valuesMap);
          } catch (err) {
            console.error("Error loading lab tests for edit:", err);
            setEditLabTests([]);
            setEditTestValues({});
          }
        } else {
          setEditLabTests([]);
          setEditTestValues({});
        }
      } else {
        // Fallback if detail fetch fails but we have basic lab_id
        if (lab.lab_id) fetchServicesForLab(lab.lab_id);
      }
    } catch (err) {
      console.error("Error fetching lab request details:", err);
      // Fallback
      if (lab.lab_id) fetchServicesForLab(lab.lab_id);
    }

    // 5. Load attachments separately
    try {
      const res = await axiosInstance.get(
        `getLabRequestAttachmentsByLabRequestId/${lab.request_id}`
      );
      if (res.data.success) {
        setEditAttachments(res.data.data);
      } else {
        setEditAttachments([]);
      }
    } catch (err) {
      console.error("Error fetching attachments:", err);
      setEditAttachments([]);
    }
  };

  // Update handleEditChange to handle discount fields
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditData((prev) => ({ ...prev, [name]: value }));

    if (name === "lab_id") {
      setEditData((prev) => ({
        ...prev,
        lab_id: value,
        serviceIds: [], // Reset services when lab changes
        discount_type: "Amount",
        discount_value: "",
      }));
      fetchServicesForLab(value);
    }
  };

  // Update handleEditSubmit to send serviceIds as an array (required by backend)
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axiosInstance.put(
        `editLabRequest/${editData.request_id}`,
        {
          lab_id: editData.lab_id,
          title: editData.title,
          description: editData.description,
          serviceIds: editData.serviceIds || [],
          serviceQuantities: editData.serviceQuantities || {},
          discount_type: editData.discount_type,
          discount_value: editData.discount_value,
        }
      );
      if (res.data.success) {
        // Save lab test values if any tests are loaded
        if (editLabTests.length > 0) {
          try {
            const testValuesPayload = editLabTests.map((t) => ({
              lab_test_id: t.id,
              value: editTestValues[t.id] !== undefined ? editTestValues[t.id] : null,
            }));
            await axiosInstance.post(`saveLabReportValues`, {
              lab_request_id: editData.request_id,
              test_values: testValuesPayload,
            });
          } catch (err) {
            console.error("Failed to save test values:", err);
          }
        }

        setLabRequests((prev) =>
          prev.map((item) =>
            item.request_id === editData.request_id
              ? {
                ...item,
                lab_id: editData.lab_id,
                title: editData.title,
                description: editData.description,
              }
              : item
          )
        );
        setEditLabTests([]);
        setEditTestValues({});
        setShowEditModal(false);
        Swal.fire("Success", "Lab request updated successfully", "success");
        setRefreshFlag((f) => f + 1);
      } else {
        Swal.fire(
          "Error",
          res.data.message || "Failed to update lab request",
          "error"
        );
      }
    } catch {
      Swal.fire("Error", "Server error while updating lab request", "error");
    }
  };


  const handleViewAttachments = (lab) => {
    setSelectedLabRequest(lab);
    setShowViewAttachmentsModal(true);

    axiosInstance
      .get(`getLabRequestAttachmentsByLabRequestId/${lab.request_id}`)
      .then((res) => {
        if (res.data.success) {
          setViewAttachments(res.data.data);
        } else {
          setViewAttachments([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching attachments:", err);
        setViewAttachments([]);
      });
  };


  const handleDeleteAttachment = async (attachmentId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this attachment!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axiosInstance.delete(
            `deleteLabRequestAttachment/${attachmentId}`
          );
          if (res.data.success) {
            setEditAttachments((prev) =>
              prev.filter((att) => att.attachment_id !== attachmentId)
            );
            Swal.fire(
              "Deleted!",
              "The attachment has been deleted.",
              "success"
            );
          } else {
            Swal.fire(
              "Error",
              res.data.message || "Failed to delete attachment",
              "error"
            );
          }
        } catch {
          Swal.fire("Error", "Server error while deleting attachment", "error");
        }
      }
    });
  };

  const handleReportFileChange = (e) => {
    const newFiles = Array.from(e.target.files || []);
    setReportFiles((prev) => [...prev, ...newFiles]);
    // Allow re-selecting the same file(s) again later
    e.target.value = "";
  };

  const handleRemoveReportFile = (index) => {
    setReportFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleReportUpload = async () => {
    try {
      // Save test values (always, even without a file)
      if (reportLabTests.length > 0) {
        const testValuesPayload = reportLabTests.map((t) => ({
          lab_test_id: t.id,
          value: reportTestValues[t.id] !== undefined ? reportTestValues[t.id] : null,
        }));
        await axiosInstance.post(`saveLabReportValues`, {
          lab_request_id: reportLabId,
          test_values: testValuesPayload,
          done_by: loggedInUserName,
        });
      }

      // Upload file attachments only if files were selected
      if (reportFiles.length > 0) {
        const stripExt = (fileName) => fileName.replace(/\.[^/.]+$/, "");
        for (let i = 0; i < reportFiles.length; i++) {
          const file = reportFiles[i];
          const name = reportFiles.length > 1
            ? (reportName ? `${reportName} (${i + 1})` : stripExt(file.name))
            : (reportName || stripExt(file.name));

          const formData = new FormData();
          formData.append("file", file);
          formData.append("name", name);
          const res = await axiosInstance.post(
            `addLabRequestAttachment/${reportLabId}`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          if (!res.data.success) {
            Swal.fire("Error", res.data.message || `Failed to upload ${file.name}`, "error");
            return;
          }
        }
      }

      setShowReportModal(false);
      setRefreshFlag((f) => f + 1);
      Swal.fire("Success", "Report saved successfully", "success");
    } catch (err) {
      Swal.fire("Error", "Server error while saving report", "error");
    }
  };

  const handleCloseReportModal = () => {
    if (importedPdfFile) {
      handleDeleteImportedFile();
    }
    setShowReportModal(false);
  };

  const handleImportResultsClick = () => {
    if (!reportLabTests.length) {
      Swal.fire("No Tests", "There are no lab tests linked to this request to import results into.", "info");
      return;
    }
    importedPdfInputRef.current?.click();
  };

  const handleImportResultsFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;

    setParsingPdf(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await axiosInstance.post(
        `parseLabReportPdf/${reportLabId}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (!res.data.success) {
        Swal.fire("Error", res.data.message || "Failed to parse PDF", "error");
        return;
      }

      const extracted = res.data.extracted || {};
      const extractedIds = Object.keys(extracted);
      if (extractedIds.length > 0) {
        setReportTestValues((prev) => ({ ...prev, ...extracted }));
        setAutoFilledTestIds((prev) => new Set([...prev, ...extractedIds]));
        const total = reportLabTests.length || extractedIds.length;
        Swal.fire({
          toast: true,
          position: "top-end",
          icon: extractedIds.length < total ? "warning" : "success",
          title: `Filled ${extractedIds.length} of ${total} tests — please review`,
          showConfirmButton: false,
          timer: 3500,
        });
      } else {
        Swal.fire("No Values Found", "Couldn't read any results from this PDF. Please enter results manually.", "warning");
      }

      setImportedPdfFile({ filename: res.data.filename, original_name: file.name });
    } catch (err) {
      Swal.fire("Error", "Server error while parsing PDF", "error");
    } finally {
      setParsingPdf(false);
    }
  };

  const handleKeepImportedFile = async () => {
    if (!importedPdfFile) return;
    try {
      const res = await axiosInstance.post(`confirmLabReportAttachment/${reportLabId}`, {
        filename: importedPdfFile.filename,
        name: importedPdfFile.original_name.replace(/\.[^/.]+$/, ""),
      });
      if (!res.data.success) {
        Swal.fire("Error", res.data.message || "Failed to save attachment", "error");
        return;
      }
      setImportedPdfFile(null);
    } catch (err) {
      Swal.fire("Error", "Server error while saving attachment", "error");
    }
  };

  const handleDeleteImportedFile = async () => {
    if (!importedPdfFile) return;
    try {
      await axiosInstance.delete(`deleteUploadedLabReportFile/${importedPdfFile.filename}`);
    } catch (err) {
      // Best-effort cleanup; a failed delete just leaves a harmless orphan file server-side
    } finally {
      setImportedPdfFile(null);
    }
  };

  const sendLabWhatsApp = async (lab) => {
    try {
      const res = await axiosInstance.post(`sendLabWhatsApp/${lab.request_id}`);
      if (res.data?.success && res.data?.phone) {
        const text = encodeURIComponent(res.data.message || "");
        window.open(
          `https://api.whatsapp.com/send?phone=${res.data.phone}&text=${text}`,
          "_blank"
        );
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: res.data?.message || "Failed to prepare WhatsApp message.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "An error occurred while preparing the WhatsApp message.",
      });
    }
  };

  const openWhatsappModal = async () => {
    setShowWhatsappModal(true);
    setLoadingSmsTemplates(true);
    try {
      const [tplRes, defaultRes] = await Promise.all([
        axiosInstance.get("getAllSmsTemplates"),
        axiosInstance.get("getDefaultNotificationTemplate", {
          params: { module_key: "lab", channel: "whatsapp" },
        }),
      ]);
      const list = Array.isArray(tplRes.data)
        ? tplRes.data
        : tplRes.data?.data || [];
      setSmsTemplates(list);
      const existing = defaultRes.data?.data;
      setSelectedWhatsappTemplate(
        existing?.template_id ? String(existing.template_id) : ""
      );
    } catch (error) {
      setSmsTemplates([]);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message || "Failed to load SMS templates.",
      });
    } finally {
      setLoadingSmsTemplates(false);
    }
  };

  const saveWhatsappTemplate = async () => {
    if (!selectedWhatsappTemplate) {
      Swal.fire({
        icon: "warning",
        title: "Select a template",
        text: "Please select an SMS template to set as the Lab default.",
      });
      return;
    }
    setSavingWhatsappTemplate(true);
    try {
      await axiosInstance.post("saveDefaultNotificationTemplate", {
        module_key: "lab",
        channel: "whatsapp",
        template_id: Number(selectedWhatsappTemplate),
      });
      setShowWhatsappModal(false);
      Swal.fire({
        icon: "success",
        title: "Saved",
        text: "Default WhatsApp notification template for Lab has been saved.",
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.message ||
          "Failed to save the default notification template.",
      });
    } finally {
      setSavingWhatsappTemplate(false);
    }
  };

  // download excel
  const handelecli = async () => {
    try {
      const response = await axiosInstance.get(`dashboard/lab_request_report`, {
        responseType: "blob", //  ye important hai
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Report.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8ecf0', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 10 }}>
          <button
            onClick={() => navigate(-1)}
            title="Back"
            style={{ width: 30, height: 30, borderRadius: 8, border: '1px solid #e8ecf0', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, marginRight: 4, flexShrink: 0 }}
            onMouseEnter={e => { e.currentTarget.style.background = '#4680ff22'; e.currentTarget.style.color = '#4680ff' }}
            onMouseLeave={e => { e.currentTarget.style.background = '#f8f9fb'; e.currentTarget.style.color = '#5B6B79' }}
          ><i className="ti ti-arrow-left" /></button>
          <div style={{ width: 32, height: 32, borderRadius: 8, background: '#4680ff20', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <i className="ti ti-flask" style={{ color: '#4680ff', fontSize: 17 }} />
          </div>
          <div>
            <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>Labs</div>
            <div style={{ fontSize: 11, color: '#5B6B79' }}>Manage lab requests, tests, and services</div>
          </div>
          <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
            <button
              className="borderBtn d-flex align-items-center gap-1"
              onClick={openWhatsappModal}
              title="Set the default WhatsApp notification template for Labs"
            >
              <i className="ti ti-brand-whatsapp" style={{ fontSize: 15 }} />
              Whatsapp Notification
            </button>
            <button
              className="borderBtn"
              onClick={() => navigate("/Admin/newrequest")}
              disabled={!permissions.newRequest}
            >
              {" "}
              New Request
            </button>
            <button
              className="borderBtn"
              onClick={() => {
                navigate("/Admin/addlabs");
              }}
              disabled={!permissions.labs}
            >
              Labs
            </button>
            <button
              className="borderBtn"
              onClick={() => {
                navigate("/Admin/labservices");
              }}
              disabled={!permissions.labServices}
            >
              Lab Services
            </button>
          </div>
        </div>
        <div className="my-12 labPage" style={{ marginTop: '18px' }}>
          <div className="w-100" style={{ borderBottom: "2px solid #e0e7ff" }}>
            <ul
              className="nav w-100"
              id="pills-tab"
              role="tablist"
              style={{ gap: 0, flexWrap: "nowrap", marginBottom: "-2px" }}
            >
              {[
                { key: "Not Sent",  label: "New",      icon: "ti-test-pipe", activeColor: "#4680ff", activeBg: "#fff", borderColor: "#4680ff" },
                { key: "Pending",   label: "Pending",  icon: "ti-clock",     activeColor: "#fd7e14", activeBg: "#fff", borderColor: "#fd7e14" },
                { key: "Received",  label: "Received", icon: "ti-check",     activeColor: "#2ca87f", activeBg: "#fff", borderColor: "#2ca87f" },
              ].map(({ key, label, icon, activeColor, borderColor }) => {
                const isActive = selectedTab === key;
                return (
                  <li key={key} className="nav-item" role="presentation" style={{ position: "relative" }}>
                    <button
                      type="button"
                      role="tab"
                      onClick={() => setSelectedTab(key)}
                      style={{
                        padding: "10px 24px",
                        fontWeight: isActive ? 700 : 500,
                        fontSize: "14px",
                        color: isActive ? activeColor : "#6b7280",
                        background: isActive ? "#fff" : "transparent",
                        border: "none",
                        borderTop: isActive ? `3px solid ${activeColor}` : "3px solid transparent",
                        borderBottom: isActive ? "2px solid #fff" : "none",
                        borderLeft: "none",
                        borderRight: "none",
                        cursor: "pointer",
                        outline: "none",
                        position: "relative",
                        zIndex: isActive ? 2 : 1,
                        transition: "color 0.15s",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <i className={`ti ${icon} me-2`} style={{ fontSize: "15px" }} />
                      {label}
                      {isActive && labRequests.length > 0 && (
                        <span style={{
                          background: activeColor,
                          color: "#fff",
                          borderRadius: "10px",
                          padding: "1px 8px",
                          marginLeft: 7,
                          fontSize: "11px",
                          fontWeight: 700,
                        }}>{labRequests.length}</span>
                      )}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="tab-content" id="pills-tabContent">
            <div
              className={`px-0 tab-pane fade${selectedTab === "Not Sent" ? " show active" : ""
                }`}
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <div className="col-12">
                <div className="card table-card">
                  <div className="tableHeader">
                    <div className="d-flex ">
                      {/* new tab */}
                      <h5 className="mb-3 mb-sm-0"></h5>
                      <div style={{ width: "300px", position: "relative" }}>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by date, name, mobile, CPR, title, req#..."
                          value={searchLab}
                          onChange={(e) => {
                            setSearchLab(e.target.value);
                            setCurrentPage(1);
                          }}
                          style={{ paddingLeft: "35px", marginBottom: "unset" }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                            color: "#888",
                          }}
                        >
                          <i className="ti ti-search f-16"></i>
                        </span>
                      </div>
                      <button className="export" onClick={handelecli}>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="28"
                          height="28"
                          viewBox="0 0 24 24"
                          fill="none"
                          style={{
                            marginTop: 4,
                            marginRight: 4,
                            marginLeft: 4,
                          }}
                        >
                          <path
                            d="M9 17.75c-.1 0-.19-.02-.29-.06a.74.74 0 0 1-.46-.69v-6c0-.41.34-.75.75-.75s.75.34.75.75v4.19l.72-.72c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-2 2c-.14.14-.34.22-.53.22Z"
                            fill="currentColor"
                          />
                          <path
                            d="M9 17.751c-.19 0-.38-.07-.53-.22l-2-2a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l2 2c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22Z"
                            fill="currentColor"
                          />
                          <path
                            d="M15 22.75H9c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h5c.41 0 .75.34.75.75s-.34.75-.75.75H9C4.39 2.75 2.75 4.39 2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 5.43-2.32 7.75-7.75 7.75Z"
                            fill="currentColor"
                          />
                          <path
                            d="M22 10.748h-4c-3.42 0-4.75-1.33-4.75-4.75v-4c0-.3.18-.58.46-.69.28-.12.6-.05.82.16l8 8a.751.751 0 0 1-.53 1.28Zm-7.25-6.94v2.19c0 2.58.67 3.25 3.25 3.25h2.19l-5.44-5.44Z"
                            fill="currentColor"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  <div>
                    <div className="table-responsive serviceTable">
                      <table className="table m-0" id="pc-dt-simple" style={{ fontSize: "13px" }}>
                        <thead style={{ background: "#1e2a4a" }}>
                          <tr style={{ color: "#c8d5f5" }}>
                            <th>Req#</th>
                            <th>Date</th>
                            <th>Name</th>
                            <th>(age) Gender</th>
                            <th>Mobile</th>
                            <th>CPR</th>
                            <th>Lab</th>
                            {/* <th>Service</th> */}
                            {/* <th>Category</th> */}
                            <th>Title</th>
                            {/* <th>Services</th> */}
                            <th>Days</th>
                            <th>Sent By</th>
                            <th>Status</th>
                            <th>Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="13">Loading...</td>
                            </tr>
                          ) : error ? (
                            <tr>
                              <td colSpan="13" className="text-danger">
                                {error}
                              </td>
                            </tr>
                          ) : paginatedLabRequests.length === 0 ? (
                            <tr>
                              <td
                                colSpan="13"
                                className="text-center text-muted"
                              >
                                No data found
                              </td>
                            </tr>
                          ) : (
                            paginatedLabRequests.map((lab) => {
                              const isLocked = isLabRequestLocked(lab);
                              return (
                              <React.Fragment key={lab.request_id}>
                                <tr>
                                  <td rowSpan={2} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                    <span style={{ background: "#e8efff", color: "#4680ff", borderRadius: "8px", padding: "3px 8px", fontWeight: 700, fontSize: "12px", border: "1px solid #c5d3ff", whiteSpace: "nowrap" }}>#{lab.request_id}</span>
                                  </td>
                                  <td>
                                    {lab.request_date
                                      ? lab.request_date.split("T")[0]
                                      : ""}
                                  </td>
                                  <td>
                                    <NavLink
                                      to="/Admin/Manageappointment"
                                      state={{ patientid: { id: lab.patient_id } }}
                                      style={{
                                        textDecoration: "none",
                                        color: "#000",
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 4,
                                      }}
                                    >
                                      <i className="ti ti-user" style={{ fontSize: "13px", opacity: 0.7 }} />
                                      {lab.patient_name}
                                    </NavLink>

                                  </td>



                                  <td>{lab.age} {lab.gender}</td>
                                  <td>{lab.mobileNumber}</td>
                                  <td>{lab.patient_civil_id}</td>
                                  <td>
                                    {lab.lab_name ? (
                                      <span style={{ background: "#fef3c7", color: "#92400e", borderRadius: "6px", padding: "2px 8px", fontSize: "11px", fontWeight: 600, border: "1px solid #fde68a", whiteSpace: "nowrap" }}>
                                        <i className="ti ti-building me-1" style={{ fontSize: "10px" }} />{lab.lab_name}
                                      </span>
                                    ) : <span style={{ color: "#adb5bd" }}>—</span>}
                                  </td>
                                  {/* <td>
                                    {lab.service_name ? (
                                      <strong>{lab.service_name}</strong>
                                    ) : (
                                      <span className="text-muted">-</span>
                                    )}
                                  </td>
                                  <td>
                                    {lab.service_category ? (
                                      <span>{lab.service_category}</span>
                                    ) : (
                                      <span className="text-muted">-</span>
                                    )}
                                  </td> */}
                                  <td>{lab.title}</td>


                                  {/* lab services */}
                                  {/* <td className="wrapText">
                                  {lab.services &&
                                    lab.services.length > 0
                                    ? lab.services
                                      .map(
                                        (s) =>
                                          s.serviceName ||
                                          s.service ||
                                          s.service_name ||
                                          s.name ||
                                          ""
                                      )
                                      .join(", ")
                                    : "-"}
                                </td> */}


                                  {/* <td>{lab.description}</td> */}
                                  <td style={{ textAlign: "center" }}>
                                    {lab.days_since_request !== null && lab.days_since_request !== undefined ? (
                                      <span style={{
                                        background: lab.days_since_request <= 3 ? "#dcfce7" : lab.days_since_request <= 7 ? "#fff7ed" : "#fee2e2",
                                        color: lab.days_since_request <= 3 ? "#15803d" : lab.days_since_request <= 7 ? "#c2410c" : "#b91c1c",
                                        border: `1px solid ${lab.days_since_request <= 3 ? "#86efac" : lab.days_since_request <= 7 ? "#fed7aa" : "#fca5a5"}`,
                                        borderRadius: "12px", padding: "2px 10px", fontSize: "11px", fontWeight: 700, whiteSpace: "nowrap"
                                      }}>
                                        {lab.days_since_request}d
                                      </span>
                                    ) : <span style={{ color: "#adb5bd" }}>—</span>}
                                  </td>
                                  <td>{lab.sent_by}</td>
                                  <td>
                                    <select
                                      id={`status-select-new-${lab.request_id}`}
                                      className="form-select form-select-sm px-1 py-0"
                                      style={{
                                        minWidth: 95,
                                        fontWeight: 700,
                                        fontSize: "0.78em",
                                        height: "2em",
                                        backgroundColor: lab.status === "Not Sent" ? "#dbeafe" : lab.status === "Pending" ? "#fff7ed" : lab.status === "Received" ? "#dcfce7" : "#fee2e2",
                                        color: lab.status === "Not Sent" ? "#1d4ed8" : lab.status === "Pending" ? "#c2410c" : lab.status === "Received" ? "#15803d" : "#b91c1c",
                                        border: `1.5px solid ${lab.status === "Not Sent" ? "#93c5fd" : lab.status === "Pending" ? "#fed7aa" : lab.status === "Received" ? "#86efac" : "#fca5a5"}`,
                                        borderRadius: "8px",
                                      }}
                                      value={lab.status}
                                      title="Change status"
                                      disabled={!permissions.newRequest}
                                      onChange={async (e) => {

                                        const newStatus =
                                          e.target.value === "Cancel"
                                            ? "Cancelled"
                                            : e.target.value;
                                        try {
                                          const res = await axiosInstance.post(
                                            `updateLabRequestStatus/${lab.request_id}`,
                                            { status: newStatus }
                                          );
                                          if (res.data.success) {
                                            setRefreshFlag((f) => f + 1);
                                            Swal.fire(
                                              "Success",
                                              "Status updated successfully",
                                              "success"
                                            );
                                          } else {
                                            Swal.fire(
                                              "Error",
                                              res.data.message ||
                                              "Failed to update status",
                                              "error"
                                            );
                                          }
                                        } catch {
                                          Swal.fire(
                                            "Error",
                                            "Server error while updating status",
                                            "error"
                                          );
                                        }
                                      }}
                                    >
                                      <option value={lab.status} disabled>
                                        {lab.status === "Pending"
                                          ? "Sent"
                                          : lab.status}
                                      </option>
                                      {lab.status !== "Not Sent" && (
                                        <option value="Not Sent">Not Sent</option>
                                      )}
                                      {lab.status !== "Pending" && (
                                        <option value="Pending">Sent</option>
                                      )}
                                      {lab.status !== "Cancel" && (
                                        <option value="Cancel">Cancel</option>
                                      )}
                                    </select>
                                  </td>
                                  <td>
                                    <div
                                      onClick={() =>
                                        navigate(
                                          `/Admin/ViewLab/${lab.request_id}`
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                      className="avtar avtar-xs btn-link-secondary viewIcon"
                                    >
                                      <i className="ti ti-eye f-20" />
                                      <span>View</span>
                                    </div>
                                    {permissions.newRequest && (
                                      <>
                                        <div
                                          onClick={() => handleEditClick(lab)}
                                          style={{ cursor: "pointer" }}
                                          className="avtar avtar-xs btn-link-secondary editIcon"
                                        >
                                          <i className="ti ti-edit f-20" />
                                          <span>Edit</span>
                                        </div>
                                        <div
                                          onClick={isLocked ? undefined : () => handleDelete(lab.request_id)}
                                          style={{ cursor: isLocked ? "not-allowed" : "pointer", opacity: isLocked ? 0.4 : 1, pointerEvents: isLocked ? "none" : "auto" }}
                                          className="avtar avtar-xs btn-link-secondary deleteIcon"
                                          title={isLocked ? "Record is locked and cannot be deleted" : "Delete"}
                                        >
                                          <i className="ti ti-trash f-20" />
                                          <span>Delete</span>
                                        </div>
                                      </>
                                    )}
                                  </td>
                                </tr>
                                <tr style={{ background: "#f0f4ff", borderBottom: "3px solid #d4e0ff" }}>
                                  <td style={{ padding: "3px 8px", fontSize: "13px", fontWeight: 700, color: "#8896c8", textTransform: "uppercase", letterSpacing: "0.5px", verticalAlign: "middle" }}>Service</td>
                                  <td colSpan={11} style={{ padding: "3px 8px", maxWidth: 0 }}>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4, maxWidth: "100%" }}>
                                      {lab.services && lab.services.length > 0
                                        ? lab.services.map((s, i) => (
                                            <span key={i} style={{ display: "inline-block", background: "#e8efff", color: "#4680ff", borderRadius: "10px", padding: "1px 10px", fontSize: "11px", fontWeight: 600, border: "1px solid #c5d3ff" }}>
                                              {s.serviceName || s.service || s.service_name || s.name || ""}
                                            </span>
                                          ))
                                        : <span style={{ color: "#adb5bd", fontSize: "11px" }}>—</span>}
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>

                              );
                            })
                          )}
                        </tbody>
                      </table>
                      {totalPages > 1 && (<div className="d-flex justify-content-end mt-3 mb-2">
                        <TablePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          setCurrentPage={setCurrentPage}
                        />
                      </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`px-0 tab-pane fade${selectedTab === "Pending" ? " show active" : ""
                }`}
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div className="col-12">
                <div className="card table-card">
                  <div className="tableHeader">
                    <div className="d-sm-flex align-items-center justify-content-between flex-row-reverse">
                      {/* pending tab */}
                      <h5 className="mb-3 mb-sm-0"></h5>
                      <div style={{ width: "300px", position: "relative" }}>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by date, name, mobile, CPR, title, req#..."
                          value={searchLab}
                          onChange={(e) => {
                            setSearchLab(e.target.value);
                            setCurrentPage(1);
                          }}
                          style={{ paddingLeft: "35px", marginBottom: "unset" }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                            color: "#888",
                          }}
                        >
                          <i className="ti ti-search f-16"></i>
                        </span>
                      </div>
                      {/* <div><a href="../admins/course-teacher-apply.html" className="btn btn-outline-secondary">Apply Teacher List</a> <a href="../admins/course-teacher-add.html" className="btn btn-primary">Add Teacher</a></div> */}
                    </div>
                  </div>
                  <div>
                    <div className="table-responsive serviceTable">
                      <table className="table m-0" id="pc-dt-simple" style={{ fontSize: "13px" }}>
                        <thead style={{ background: "#1e2a4a" }}>
                          <tr style={{ color: "#c8d5f5" }}>
                            <th>Req#</th>
                            <th>Date</th>
                            <th>Name</th>
                            <th>(age) Gender</th>
                            <th>Mobile</th>
                            <th>CPR</th>
                            <th>Lab</th>
                            {/* <th>Service</th> */}
                            {/* <th>Category</th> */}
                            <th>Title</th>
                            {/* <th>Services</th> */}
                            <th>Days</th>
                            <th>Sent By</th>
                            <th>Status</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="13">Loading...</td>
                            </tr>
                          ) : error ? (
                            <tr>
                              <td colSpan="13" className="text-danger">
                                {error}
                              </td>
                            </tr>
                          ) : paginatedLabRequests.length === 0 ? (
                            <tr>
                              <td
                                colSpan="13"
                                className="text-center text-muted"
                              >
                                No data found
                              </td>
                            </tr>
                          ) : (
                            paginatedLabRequests.map((lab) => {
                              const isLocked = isLabRequestLocked(lab);
                              return (
                              <React.Fragment key={lab.request_id}>
                                <tr>
                                  <td rowSpan="2" style={{ verticalAlign: "middle", textAlign: "center" }}>
                                    <span style={{ background: "#e8efff", color: "#4680ff", borderRadius: "8px", padding: "3px 8px", fontWeight: 700, fontSize: "12px", border: "1px solid #c5d3ff", whiteSpace: "nowrap" }}>#{lab.request_id}</span>
                                  </td>
                                  <td>
                                    {lab.pending_at
                                      ? lab.pending_at.split("T")[0]
                                      : ""}
                                  </td>
                                  <td>
                                    <NavLink
                                      to="/Admin/Manageappointment"
                                      state={{ patientid: { id: lab.patient_id } }}
                                      style={{
                                        textDecoration: "none",
                                        color: "#000",
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 4,
                                      }}
                                    >
                                      <i className="ti ti-user" style={{ fontSize: "13px", opacity: 0.7 }} />
                                      {lab.patient_name}
                                    </NavLink>

                                  </td>
                                  <td>{lab.age} {lab.gender}</td>
                                  <td>{lab.mobileNumber}</td>

                                  <td>{lab.patient_civil_id}</td>
                                  <td>
                                    {lab.lab_name ? (
                                      <span style={{ background: "#fef3c7", color: "#92400e", borderRadius: "6px", padding: "2px 8px", fontSize: "11px", fontWeight: 600, border: "1px solid #fde68a", whiteSpace: "nowrap" }}>
                                        <i className="ti ti-building me-1" style={{ fontSize: "10px" }} />{lab.lab_name}
                                      </span>
                                    ) : <span style={{ color: "#adb5bd" }}>—</span>}
                                  </td>
                                  {/* <td>
                                  {lab.service_name ? (
                                    <strong>{lab.service_name}</strong>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td> */}
                                  {/* <td>
                                  {lab.service_category ? (
                                    <span>{lab.service_category}</span>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td> */}
                                  <td>{lab.title}</td>
                                  {/* <td className="wrapText">
                                  {lab.services &&
                                    lab.services.length > 0
                                    ? lab.services
                                      .map(
                                        (s) =>
                                          s.serviceName ||
                                          s.service ||
                                          s.service_name ||
                                          s.name ||
                                          ""
                                      )
                                      .join(", ")
                                    : "-"}
                                </td> */}
                                  <td style={{ textAlign: "center" }}>
                                    {lab.days_since_request !== null && lab.days_since_request !== undefined ? (
                                      <span style={{
                                        background: lab.days_since_request <= 3 ? "#dcfce7" : lab.days_since_request <= 7 ? "#fff7ed" : "#fee2e2",
                                        color: lab.days_since_request <= 3 ? "#15803d" : lab.days_since_request <= 7 ? "#c2410c" : "#b91c1c",
                                        border: `1px solid ${lab.days_since_request <= 3 ? "#86efac" : lab.days_since_request <= 7 ? "#fed7aa" : "#fca5a5"}`,
                                        borderRadius: "12px", padding: "2px 10px", fontSize: "11px", fontWeight: 700, whiteSpace: "nowrap"
                                      }}>
                                        {lab.days_since_request}d
                                      </span>
                                    ) : <span style={{ color: "#adb5bd" }}>—</span>}
                                  </td>
                                  <td>{lab.sent_by}</td>
                                  <td>
                                    <select
                                      id={`status-select-pending-${lab.request_id}`}
                                      className="form-select form-select-sm px-1 py-0"
                                      style={{
                                        minWidth: 95,
                                        fontWeight: 700,
                                        fontSize: "0.78em",
                                        height: "2em",
                                        backgroundColor: lab.status === "Not Sent" ? "#dbeafe" : lab.status === "Pending" ? "#fff7ed" : lab.status === "Received" ? "#dcfce7" : "#fee2e2",
                                        color: lab.status === "Not Sent" ? "#1d4ed8" : lab.status === "Pending" ? "#c2410c" : lab.status === "Received" ? "#15803d" : "#b91c1c",
                                        border: `1.5px solid ${lab.status === "Not Sent" ? "#93c5fd" : lab.status === "Pending" ? "#fed7aa" : lab.status === "Received" ? "#86efac" : "#fca5a5"}`,
                                        borderRadius: "8px",
                                      }}
                                      value={lab.status}
                                      title="Change status"
                                      disabled={!permissions.newRequest}
                                      onChange={async (e) => {

                                        const newStatus =
                                          e.target.value === "Cancel"
                                            ? "Cancelled"
                                            : e.target.value;
                                        try {
                                          const res = await axiosInstance.post(
                                            `updateLabRequestStatus/${lab.request_id}`,
                                            { status: newStatus }
                                          );
                                          if (res.data.success) {
                                            setRefreshFlag((f) => f + 1);
                                            Swal.fire(
                                              "Success",
                                              "Status updated successfully",
                                              "success"
                                            );
                                          } else {
                                            Swal.fire(
                                              "Error",
                                              res.data.message ||
                                              "Failed to update status",
                                              "error"
                                            );
                                          }
                                        } catch {
                                          Swal.fire(
                                            "Error",
                                            "Server error while updating status",
                                            "error"
                                          );
                                        }
                                      }}
                                    >
                                      <option value={lab.status} disabled>
                                        {lab.status === "Pending"
                                          ? "Sent"
                                          : lab.status === "Received"
                                            ? "Completed"
                                            : lab.status}
                                      </option>
                                      {lab.status !== "Pending" && (
                                        <option value="Pending">Sent</option>
                                      )}
                                      {lab.status !== "Received" && (
                                        <option value="Received">
                                          Completed
                                        </option>
                                      )}
                                      {lab.status !== "Cancel" && (
                                        <option value="Cancel">Cancel</option>
                                      )}
                                    </select>
                                  </td>
                                  <td className="text-center">
                                    <div
                                      onClick={() =>
                                        navigate(
                                          `/Admin/ViewLab/${lab.request_id}`
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                      className="avtar avtar-xs btn-link-secondary viewIcon"
                                    >
                                      <i className="ti ti-eye f-20" />
                                      <span>View</span>
                                    </div>
                                    {permissions.newRequest && (
                                      <>
                                        <div
                                          onClick={() => handleEditClick(lab)}
                                          style={{ cursor: "pointer" }}
                                          className="avtar avtar-xs btn-link-secondary editIcon"
                                        >
                                          <i className="ti ti-edit f-20" />
                                          <span>Edit</span>
                                        </div>
                                        <div
                                          onClick={isLocked ? undefined : () => handleDelete(lab.request_id)}
                                          style={{ cursor: isLocked ? "not-allowed" : "pointer", opacity: isLocked ? 0.4 : 1, pointerEvents: isLocked ? "none" : "auto" }}
                                          className="avtar avtar-xs btn-link-secondary deleteIcon"
                                          title={isLocked ? "Record is locked and cannot be deleted" : "Delete"}
                                        >
                                          <i className="ti ti-trash f-20" />
                                          <span>Delete</span>
                                        </div>
                                      </>
                                    )}
                                  </td>
                                </tr>
                                <tr style={{ background: "#f0f4ff", borderBottom: "3px solid #d4e0ff" }}>
                                  <td style={{ padding: "3px 8px", fontSize: "13px", fontWeight: 700, color: "#8896c8", textTransform: "uppercase", letterSpacing: "0.5px", verticalAlign: "middle" }}>Service</td>
                                  <td colSpan="11" style={{ padding: "3px 8px", maxWidth: 0 }}>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4, maxWidth: "100%" }}>
                                      {lab.services?.length
                                        ? lab.services.map((s, i) => (
                                            <span key={i} style={{ display: "inline-block", background: "#e8efff", color: "#4680ff", borderRadius: "10px", padding: "1px 10px", fontSize: "11px", fontWeight: 600, border: "1px solid #c5d3ff" }}>
                                              {s.serviceName || s.service || s.service_name || s.name}
                                            </span>
                                          ))
                                        : <span style={{ color: "#adb5bd", fontSize: "11px" }}>—</span>}
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                      {totalPages > 1 && (<div className="d-flex justify-content-end mt-3 mb-2">
                        <TablePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          setCurrentPage={setCurrentPage}
                        />
                      </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`px-0 tab-pane fade${selectedTab === "Received" ? " show active" : ""
                }`}
              id="pills-contact"
              role="tabpanel"
              aria-labelledby="pills-contact-tab"
            >
              <div className="col-12">
                <div className="card table-card">
                  <div className="tableHeader">
                    <div className="d-sm-flex align-items-center justify-content-between flex-row-reverse">
                      {/* received tab */}
                      <h5 className="mb-3 mb-sm-0"></h5>
                      <div style={{ width: "300px", position: "relative" }}>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search by date, name, mobile, CPR, title, req#..."
                          value={searchLab}
                          onChange={(e) => {
                            setSearchLab(e.target.value);
                            setCurrentPage(1);
                          }}
                          style={{ paddingLeft: "35px", marginBottom: "unset" }}
                        />
                        <span
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "10px",
                            transform: "translateY(-50%)",
                            pointerEvents: "none",
                            color: "#888",
                          }}
                        >
                          <i className="ti ti-search f-16"></i>
                        </span>
                      </div>
                      {/* <div><a href="../admins/course-teacher-apply.html" className="btn btn-outline-secondary">Apply Teacher List</a> <a href="../admins/course-teacher-add.html" className="btn btn-primary">Add Teacher</a></div> */}
                    </div>
                  </div>
                  <div>
                    <div className="table-responsive serviceTable">
                      <table className="table m-0" id="pc-dt-simple" style={{ fontSize: "13px" }}>
                        <thead style={{ background: "#1e2a4a" }}>
                          <tr style={{ color: "#c8d5f5" }}>
                            <th>Req#</th>
                            <th>Date</th>
                            <th>Name</th>
                            <th>(age) Gender</th>
                            <th>Mobile</th>
                            <th>CPR</th>
                            <th>Lab</th>
                            {/* <th>Service</th> */}
                            {/* <th>Category</th> */}
                            <th>Title</th>
                            {/* <th>Services</th> */}
                            <th>Days</th>
                            <th>Sent By</th>
                            <th>Attachments</th>
                            <th className="text-center">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loading ? (
                            <tr>
                              <td colSpan="13">Loading...</td>
                            </tr>
                          ) : error ? (
                            <tr>
                              <td colSpan="13" className="text-danger">
                                {error}
                              </td>
                            </tr>
                          ) : paginatedLabRequests.length === 0 ? (
                            <tr>
                              <td
                                colSpan="13"
                                className="text-center text-muted"
                              >
                                No data found
                              </td>
                            </tr>
                          ) : (
                            paginatedLabRequests.map((lab) => {
                              const isLocked = isLabRequestLocked(lab);
                              return (
                              <React.Fragment key={lab.request_id}>
                                <tr>
                                  <td rowSpan={2} style={{ verticalAlign: "middle", textAlign: "center" }}>
                                    <span style={{ background: "#e8efff", color: "#4680ff", borderRadius: "8px", padding: "3px 8px", fontWeight: 700, fontSize: "12px", border: "1px solid #c5d3ff", whiteSpace: "nowrap" }}>#{lab.request_id}</span>
                                  </td>
                                  <td>
                                    {lab.received_at
                                      ? lab.received_at.split("T")[0]
                                      : ""}
                                  </td>
                                  <td>
                                    <NavLink
                                      to="/Admin/Manageappointment"
                                      state={{ patientid: { id: lab.patient_id } }}
                                      style={{
                                        textDecoration: "none",
                                        color: "#000",
                                        fontWeight: 600,
                                        fontSize: "13px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 4,
                                      }}
                                    >
                                      <i className="ti ti-user" style={{ fontSize: "13px", opacity: 0.7 }} />
                                      {lab.patient_name}
                                    </NavLink>

                                  </td>
                                  <td>{lab.age} {lab.gender}</td>
                                  <td>
                                    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
                                      {lab.mobileNumber}
                                      {lab.mobileNumber && (
                                        <i
                                          className="ti ti-brand-whatsapp"
                                          title="Send WhatsApp Notification"
                                          onClick={() => sendLabWhatsApp(lab)}
                                          style={{ color: "#25D366", fontSize: 16, cursor: "pointer" }}
                                        />
                                      )}
                                    </span>
                                  </td>
                                  <td>{lab.patient_civil_id}</td>
                                  <td>
                                    {lab.lab_name ? (
                                      <span style={{ background: "#fef3c7", color: "#92400e", borderRadius: "6px", padding: "2px 8px", fontSize: "11px", fontWeight: 600, border: "1px solid #fde68a", whiteSpace: "nowrap" }}>
                                        <i className="ti ti-building me-1" style={{ fontSize: "10px" }} />{lab.lab_name}
                                      </span>
                                    ) : <span style={{ color: "#adb5bd" }}>—</span>}
                                  </td>
                                  {/* <td>
                                  {lab.service_name ? (
                                    <strong>{lab.service_name}</strong>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td> */}
                                  {/* <td>
                                  {lab.service_category ? (
                                    <span>{lab.service_category}</span>
                                  ) : (
                                    <span className="text-muted">-</span>
                                  )}
                                </td> */}
                                  <td>{lab.title}</td>
                                  {/* <td className="wrapText">
                                  {lab.services &&
                                    lab.services.length > 0
                                    ? lab.services
                                      .map(
                                        (s) =>
                                          s.serviceName ||
                                          s.service ||
                                          s.service_name ||
                                          s.name ||
                                          ""
                                      )
                                      .join(", ")
                                    : "-"}
                                </td> */}

                                  <td style={{ textAlign: "center" }}>
                                    {lab.days_since_request !== null && lab.days_since_request !== undefined ? (
                                      <span style={{
                                        background: lab.days_since_request <= 3 ? "#dcfce7" : lab.days_since_request <= 7 ? "#fff7ed" : "#fee2e2",
                                        color: lab.days_since_request <= 3 ? "#15803d" : lab.days_since_request <= 7 ? "#c2410c" : "#b91c1c",
                                        border: `1px solid ${lab.days_since_request <= 3 ? "#86efac" : lab.days_since_request <= 7 ? "#fed7aa" : "#fca5a5"}`,
                                        borderRadius: "12px", padding: "2px 10px", fontSize: "11px", fontWeight: 700, whiteSpace: "nowrap"
                                      }}>
                                        {lab.days_since_request}d
                                      </span>
                                    ) : <span style={{ color: "#adb5bd" }}>—</span>}
                                  </td>
                                  <td>{lab.sent_by}</td>
                                  <td>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                      <button
                                        className="btn btn-sm"
                                        style={{ fontSize: "0.78em", padding: "3px 10px", background: "#e8efff", color: "#4680ff", border: "1px solid #c5d3ff", fontWeight: 600, borderRadius: "6px" }}
                                        onClick={() => handleAddReportClick(lab)}
                                      >
                                        <i className="ti ti-pencil me-1" />Add Results
                                      </button>
                                      <button
                                        className="btn btn-sm"
                                        style={{ fontSize: "0.78em", padding: "3px 10px", background: "#dcfce7", color: "#15803d", border: "1px solid #86efac", fontWeight: 600, borderRadius: "6px" }}
                                        onClick={() => handleGenerateReport(lab)}
                                      >
                                        <i className="ti ti-file-text me-1" />Generate Report
                                      </button>
                                    </div>
                                  </td>
                                  <td>
                                    <div
                                      onClick={() =>
                                        navigate(
                                          `/Admin/ViewLab/${lab.request_id}`
                                        )
                                      }
                                      style={{ cursor: "pointer" }}
                                      className="avtar avtar-xs btn-link-secondary viewIcon"
                                    >
                                      <i className="ti ti-eye f-20" />
                                      <span>View</span>
                                    </div>
                                    {permissions.newRequest && (
                                      <>
                                        <div
                                          onClick={() => handleEditClick(lab)}
                                          style={{ cursor: "pointer" }}
                                          className="avtar avtar-xs btn-link-secondary editIcon"
                                        >
                                          <i className="ti ti-edit f-20" />
                                          <span>Edit</span>
                                        </div>
                                        <div
                                          onClick={isLocked ? undefined : () => handleDelete(lab.request_id)}
                                          style={{ cursor: isLocked ? "not-allowed" : "pointer", opacity: isLocked ? 0.4 : 1, pointerEvents: isLocked ? "none" : "auto" }}
                                          className="avtar avtar-xs btn-link-secondary deleteIcon"
                                          title={isLocked ? "Record is locked and cannot be deleted" : "Delete"}
                                        >
                                          <i className="ti ti-trash f-20" />
                                          <span>Delete</span>
                                        </div>
                                      </>
                                    )}
                                  </td>
                                </tr>
                                <tr style={{ background: "#f0f4ff", borderBottom: "3px solid #d4e0ff" }}>
                                  <td style={{ padding: "3px 8px", fontSize: "13px", fontWeight: 700, color: "#8896c8", textTransform: "uppercase", letterSpacing: "0.5px", verticalAlign: "middle" }}>Service</td>
                                  <td colSpan={11} style={{ padding: "3px 8px", maxWidth: 0 }}>
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 4, maxWidth: "100%" }}>
                                      {lab.services && lab.services.length > 0
                                        ? lab.services.map((s, i) => (
                                            <span key={i} style={{ display: "inline-block", background: "#e8efff", color: "#4680ff", borderRadius: "10px", padding: "1px 10px", fontSize: "11px", fontWeight: 600, border: "1px solid #c5d3ff" }}>
                                              {s.serviceName || s.service || s.service_name || s.name || ""}
                                            </span>
                                          ))
                                        : <span style={{ color: "#adb5bd", fontSize: "11px" }}>—</span>}
                                    </div>
                                  </td>
                                </tr>
                              </React.Fragment>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                      {totalPages > 1 && (<div className="d-flex justify-content-end mt-3 mb-2">
                        <TablePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          setCurrentPage={setCurrentPage}
                        />
                      </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showReportModal && (
        <div className="modal fade show" style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}>
          <div className="modal-dialog modal-xl" style={{ maxWidth: "1140px" }}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Report</h5>
                <button type="button" className="btn-close" onClick={handleCloseReportModal}></button>
              </div>
              <div className="modal-body">

                {/* Attachment section */}
                <div className="row g-3 mb-4">
                  <div className="col-md-6">
                    <label className="form-label">Report Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={reportName}
                      onChange={(e) => setReportName(e.target.value)}
                      placeholder="Enter report name"
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">
                      Import Results <span className="text-muted" style={{ fontSize: "12px" }}>(upload a PDF lab report to auto-fill values below)</span>
                    </label>
                    <div>
                      <input
                        type="file"
                        ref={importedPdfInputRef}
                        onChange={handleImportResultsFile}
                        accept="application/pdf"
                        style={{ display: "none" }}
                      />
                      <button
                        type="button"
                        className="btn btn-sm"
                        style={{ background: "#e8efff", color: "#4680ff", border: "1px solid #c5d3ff", fontWeight: 600, borderRadius: "6px" }}
                        onClick={handleImportResultsClick}
                        disabled={parsingPdf}
                      >
                        <i className={`ti ${parsingPdf ? "ti-loader-2" : "ti-file-import"} me-1`} />
                        {parsingPdf ? "Reading PDF…" : "Import Results"}
                      </button>
                    </div>
                    {importedPdfFile && (
                      <div
                        className="mt-2"
                        style={{
                          display: "flex", alignItems: "center", justifyContent: "space-between",
                          background: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: 6,
                          padding: "4px 10px", fontSize: 12.5, gap: 8,
                        }}
                      >
                        <span style={{ display: "flex", alignItems: "center", gap: 6, overflow: "hidden" }}>
                          <i className="ti ti-file-type-pdf" style={{ color: "#4680ff", flexShrink: 0 }} />
                          <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{importedPdfFile.original_name}</span>
                        </span>
                        <span style={{ display: "flex", gap: 10, flexShrink: 0 }}>
                          <span style={{ color: "#2f9e44", cursor: "pointer", fontWeight: 600 }} onClick={handleKeepImportedFile}>Keep as attachment</span>
                          <span style={{ color: "#e03131", cursor: "pointer", fontWeight: 600 }} onClick={handleDeleteImportedFile}>Delete file</span>
                        </span>
                      </div>
                    )}
                  </div>
                </div>

                <div className="row g-3 mb-4">
                  <div className="col-md-12">
                    <label className="form-label">Attachments <span className="text-muted" style={{ fontSize: "12px" }}>(optional, you can select multiple)</span></label>
                    <input
                      type="file"
                      className="form-control"
                      onChange={handleReportFileChange}
                      accept="image/*,application/pdf"
                      multiple
                    />
                    {reportFiles.length > 0 && (
                      <div className="mt-2" style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                        {reportFiles.map((file, index) => (
                          <div
                            key={`${file.name}-${index}`}
                            style={{
                              display: "flex", alignItems: "center", justifyContent: "space-between",
                              background: "#f8f9fa", border: "1px solid #e9ecef", borderRadius: 6,
                              padding: "4px 10px", fontSize: 12.5,
                            }}
                          >
                            <span style={{ display: "flex", alignItems: "center", gap: 6, overflow: "hidden" }}>
                              <i className="ti ti-paperclip" style={{ color: "#4680ff", flexShrink: 0 }} />
                              <span style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{file.name}</span>
                            </span>
                            <i
                              className="ti ti-x"
                              style={{ color: "#e03131", cursor: "pointer", flexShrink: 0, marginLeft: 8 }}
                              onClick={() => handleRemoveReportFile(index)}
                            />
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                {/* Lab Test Results */}
                {reportLabTests.length > 0 && (
                  <div>
                    <h6 style={{ fontWeight: "600", marginBottom: "12px", color: "#1a1f36" }}>
                      <i className="fas fa-flask me-2" style={{ color: "#4680ff" }}></i>
                      Lab Test Results
                    </h6>
                    <div style={{ width: "100%", overflowX: "hidden" }}>
                      <table
                        className="table table-bordered"
                        style={{ fontSize: "13px", width: "100%", tableLayout: "fixed" }}
                      >
                        <colgroup>
                          <col style={{ width: "22%" }} />
                          <col style={{ width: "16%" }} />
                          <col style={{ width: "9%" }} />
                          <col style={{ width: "15%" }} />
                          <col style={{ width: "22%" }} />
                          <col style={{ width: "11%" }} />
                        </colgroup>
                        <thead style={{ background: "#f8f9fa" }}>
                          <tr>
                            <th>Test Name</th>
                            <th>Value</th>
                            <th>Units</th>
                            <th>Range / Reference</th>
                            <th>Methodology</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {reportLabTests.map((test) => {
                            const isText = test.value_type === "text";
                            const val = reportTestValues[test.id] ?? "";
                            const status = isText ? null : getTestStatus(val, test.min_range, test.max_range);
                            const bStyle = status ? statusBadgeStyle[status] : null;
                            const isAutoFilled = autoFilledTestIds.has(test.id) || autoFilledTestIds.has(String(test.id));
                            const clearAutoFilled = () => {
                              setAutoFilledTestIds((prev) => {
                                if (!prev.has(test.id) && !prev.has(String(test.id))) return prev;
                                const next = new Set(prev);
                                next.delete(test.id);
                                next.delete(String(test.id));
                                return next;
                              });
                            };
                            return (
                              <tr key={test.id} style={{ background: bStyle ? bStyle.background + "22" : "transparent" }}>
                                <td style={{ fontWeight: "500", wordBreak: "break-word", whiteSpace: "normal" }}>
                                  {test.test_name}
                                  {isAutoFilled && (
                                    <span
                                      className="ms-2"
                                      title="Auto-filled from imported PDF — please review"
                                      style={{ background: "#e6fcf5", color: "#0ca678", border: "1px solid #96f2d7", borderRadius: 8, padding: "1px 8px", fontSize: "10px", fontWeight: 700 }}
                                    >
                                      AUTO
                                    </span>
                                  )}
                                </td>
                                <td style={{ minWidth: 0 }}>
                                  {isText ? (
                                    <input
                                      type="text"
                                      className="form-control form-control-sm"
                                      value={val}
                                      onChange={(e) => {
                                        setReportTestValues((prev) => ({ ...prev, [test.id]: e.target.value }));
                                        clearAutoFilled();
                                      }}
                                      placeholder="e.g. Negative"
                                      style={{ width: "100%", boxSizing: "border-box", borderColor: isAutoFilled ? "#0ca678" : undefined }}
                                    />
                                  ) : (
                                    <input
                                      type="number"
                                      step="0.01"
                                      className="form-control form-control-sm"
                                      value={val}
                                      onChange={(e) => {
                                        setReportTestValues((prev) => ({ ...prev, [test.id]: e.target.value }));
                                        clearAutoFilled();
                                      }}
                                      placeholder="—"
                                      style={{ borderColor: isAutoFilled ? "#0ca678" : (bStyle ? bStyle.color + "88" : undefined), width: "100%", boxSizing: "border-box" }}
                                    />
                                  )}
                                </td>
                                <td className="text-center" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{test.units || "—"}</td>
                                <td className="text-center" style={{ color: "#6c757d", fontSize: "12px", wordBreak: "break-word", whiteSpace: "normal" }}>
                                  {isText
                                    ? (test.reference_text || "—")
                                    : `${test.min_range !== null ? parseFloat(test.min_range).toFixed(2) : "—"} – ${test.max_range !== null ? parseFloat(test.max_range).toFixed(2) : "—"}`}
                                </td>
                                <td style={{ color: "#6c757d", wordBreak: "break-word", whiteSpace: "normal" }}>{test.methodology || "—"}</td>
                                <td className="text-center">
                                  {status && (
                                    <span style={{ ...bStyle, borderRadius: "10px", padding: "2px 10px", fontSize: "11px", fontWeight: "600", whiteSpace: "nowrap" }}>
                                      {statusLabel[status]}
                                    </span>
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {reportLabTests.length === 0 && (
                  <p className="text-muted" style={{ fontSize: "13px" }}>No lab tests linked to this service.</p>
                )}

              </div>
              <div className="modal-footer d-flex justify-content-between align-items-center w-100">
                <div style={{ fontSize: "13px", color: "#555" }}>
                  <i className="fas fa-user-check me-1" style={{ color: "#4680ff" }}></i>
                  <strong>Done By:</strong> {loggedInUserName || "—"}
                </div>
                <div>
                  <button type="button" className="cancelText me-2" onClick={handleCloseReportModal}>Cancel</button>
                  <button type="button" className="bgBtn" onClick={handleReportUpload}>Save Report</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showEditModal && (
        <div
          className="modal fade show"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "block",
            overflowY: "auto",
          }}
        >
          <div className="modal-dialog modal-xl" style={{ maxWidth: "980px", marginTop: "1.75rem", marginBottom: "1.75rem" }}>
            <div className="modal-content" style={{ borderRadius: 12, border: "1px solid #e8ecf0", overflow: "hidden", maxHeight: "calc(100vh - 3.5rem)", display: "flex", flexDirection: "column" }}>
              <div
                className="modal-header"
                style={{ padding: "14px 20px", borderBottom: "1px solid #e8ecf0", background: "#f8f9fb", alignItems: "center", flexShrink: 0 }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 34, height: 34, borderRadius: 8, background: "#4680ff20", display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <i className="ti ti-edit" style={{ color: "#4680ff", fontSize: 17 }} />
                  </div>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#1a202c" }}>Edit Lab Request</div>
                    <div style={{ fontSize: 11, color: "#5B6B79" }}>Update request details, services, and attachments</div>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setShowEditModal(false)}
                  style={{
                    marginLeft: "auto", width: 28, height: 28, borderRadius: 8,
                    border: "1px solid #e8ecf0", background: "#fff", cursor: "pointer",
                    display: "flex", alignItems: "center", justifyContent: "center", color: "#5B6B79", fontSize: 14,
                  }}
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form onSubmit={handleEditSubmit} style={{ display: "flex", flexDirection: "column", minHeight: 0, flex: 1 }}>
                <div className="modal-body" style={{ padding: "18px 20px", fontSize: 13, overflowY: "auto", flex: 1, minHeight: 0 }}>
                  {/* Row 1: Lab + Title */}
                  <div className="row g-3">
                    <div className="col-lg-6">
                      <label style={labelStyle}>Lab</label>
                      <select
                        className="form-select form-select-sm"
                        style={inputStyle}
                        name="lab_id"
                        value={editData.lab_id}
                        onChange={handleEditChange}
                        required
                      >
                        <option value="">Select Lab</option>
                        {labs.map((lab) => (
                          <option key={lab.id} value={lab.id}>
                            {lab.lab_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-lg-6">
                      <label style={labelStyle}>Title</label>
                      <input
                        type="text"
                        className="form-control form-control-sm"
                        style={inputStyle}
                        name="title"
                        value={editData.title}
                        onChange={handleEditChange}
                        placeholder="title"
                      />
                    </div>
                  </div>

                  {/* Description */}
                  <div className="mt-3">
                    <label style={labelStyle}>Description</label>
                    <textarea
                      className="form-control form-control-sm"
                      style={{ ...inputStyle, height: "auto" }}
                      name="description"
                      value={editData.description}
                      onChange={handleEditChange}
                    />
                  </div>

                  {/* Lab Services Autocomplete - MULTI SELECT */}
                  <div className="mt-3">
                    <label style={labelStyle}>Lab Services</label>
                    <Autocomplete
                      id="edit-lab-services"
                      multiple
                      options={labServices || []}
                      isOptionEqualToValue={(option, value) =>
                        String(option.id || option.service_id) === String(value.id || value.service_id)
                      }
                      getOptionLabel={(option) => {
                        const serviceName =
                          option.serviceName ||
                          option.service ||
                          option.service_name ||
                          option.name ||
                          "Unknown Service";
                        const category = option.category || "";
                        const price = option.price ? `${Number(option.price || 0).toFixed(3)} BHD` : "";
                        let label = serviceName;
                        if (category) label += ` (${category})`;
                        if (price) label += ` - ${price}`;
                        return label;
                      }}
                      value={
                        labServices.filter((service) =>
                          (editData.serviceIds || []).some(
                            (id) =>
                              String(service.id) === String(id) ||
                              String(service.service_id) === String(id)
                          )
                        )
                      }
                      onChange={(e, newValue) => {
                        setEditData((prev) => {
                          const newIds = (newValue || []).map((s) => s.id || s.service_id);
                          const newQuantities = {};
                          newIds.forEach((id) => {
                            newQuantities[id] = prev.serviceQuantities?.[id] || 1;
                          });
                          return {
                            ...prev,
                            serviceIds: newIds,
                            serviceQuantities: newQuantities,
                            // Reset discount when services change
                            discount_type: "Amount",
                            discount_value: "",
                          };
                        });
                      }}
                      disabled={!editData.lab_id || labServices.length === 0}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder={
                            editData.lab_id
                              ? "Search and select services..."
                              : "Please select a lab first"
                          }
                        />
                      )}
                      renderOption={(props, option) => {
                        const serviceName =
                          option.serviceName ||
                          option.service ||
                          option.service_name ||
                          option.name ||
                          "Unknown Service";
                        const category = option.category || "";
                        const price = option.price || 0;
                        return (
                          <li {...props}>
                            <div>
                              <strong>{serviceName}</strong>
                              {category && (
                                <small className="text-muted d-block">
                                  Category: {category}
                                </small>
                              )}
                              {price > 0 && (
                                <small className="text-success d-block">
                                  Price: {Number(price).toFixed(3)} BHD
                                </small>
                              )}
                            </div>
                          </li>
                        );
                      }}
                    />
                  </div>

                  {/* DISCOUNT SECTION - Only show when at least one service is selected */}
                  {editData.serviceIds && editData.serviceIds.length > 0 && (() => {
                    const selectedEditServices = labServices.filter((s) =>
                      editData.serviceIds.some((id) => String(s.id) === String(id))
                    );
                    const editQuantities = editData.serviceQuantities || {};
                    const price = selectedEditServices.reduce((sum, s) => {
                      const qty = Number(editQuantities[s.id]) > 0 ? Number(editQuantities[s.id]) : 1;
                      return sum + Number(s.price || 0) * qty;
                    }, 0);
                    const discountType = editData.discount_type || "Amount";
                    const discountValue = Number(editData.discount_value || 0);
                    const discountAmount = discountType === "Percentage"
                      ? (price * discountValue) / 100
                      : discountValue;
                    const netAmount = Math.max(0, price - discountAmount);

                    return (
                      <div style={{ background: "#f0f4ff", border: "1px solid #d4e0ff", borderRadius: 8, padding: "14px 16px", marginTop: 14 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, color: "#4680ff", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 12, display: "flex", alignItems: "center", gap: 6 }}>
                          <i className="ti ti-calculator" />
                          Price Summary
                        </div>

                        <div style={{ marginBottom: 12 }}>
                          {selectedEditServices.map((s) => {
                            const serviceName = s.serviceName || s.service || s.service_name || s.name || 'Unknown Service';
                            const unitPrice = Number(s.price || 0);
                            const qty = Number(editQuantities[s.id]) > 0 ? Number(editQuantities[s.id]) : 1;
                            return (
                              <div key={s.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 12.5, color: "#3d4a5c", padding: "3px 0" }}>
                                <span>{serviceName}{s.category ? ` (${s.category})` : ''}</span>
                                <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                  <span>{unitPrice.toFixed(3)} BHD</span>
                                  <span style={{ color: "#8a94a3" }}>×</span>
                                  <input
                                    type="number"
                                    min="1"
                                    value={qty}
                                    onChange={(e) => {
                                      const newQty = parseInt(e.target.value, 10) || 1;
                                      setEditData((prev) => ({
                                        ...prev,
                                        serviceQuantities: { ...prev.serviceQuantities, [s.id]: newQty },
                                      }));
                                    }}
                                    style={{ width: 55, fontSize: 12.5, borderRadius: 6, border: "1px solid #dde3eb", padding: "2px 4px" }}
                                  />
                                  <span style={{ fontWeight: 600, minWidth: 65, textAlign: "right" }}>{(unitPrice * qty).toFixed(3)} BHD</span>
                                </span>
                              </div>
                            );
                          })}
                        </div>

                        <div className="row g-3">
                          {/* Total Price */}
                          <div className="col-md-3">
                            <label style={labelStyle}>Total Price</label>
                            <div style={{ fontSize: 16, fontWeight: 700, color: "#4680ff" }}>
                              {price.toFixed(3)} BHD
                            </div>
                          </div>

                          {/* Discount Type */}
                          <div className="col-md-3">
                            <label style={labelStyle}>Discount Type</label>
                            <select
                              className="form-select form-select-sm"
                              style={inputStyle}
                              name="discount_type"
                              value={discountType}
                              onChange={handleEditChange}
                            >
                              <option value="Amount">By Amount (BHD)</option>
                              <option value="Percentage">By Percentage (%)</option>
                            </select>
                          </div>

                          {/* Discount Value */}
                          <div className="col-md-3">
                            <label style={labelStyle}>Discount Value</label>
                            <input
                              type="number"
                              className="form-control form-control-sm"
                              style={inputStyle}
                              name="discount_value"
                              min="0"
                              value={editData.discount_value || ""}
                              onChange={handleEditChange}
                            />
                          </div>

                          {/* Net Amount */}
                          <div className="col-md-3">
                            <label style={labelStyle}>Net Amount</label>
                            <div style={{ fontSize: 16, fontWeight: 700, color: "#2ca87f" }}>
                              {netAmount.toFixed(3)} BHD
                            </div>
                            {discountAmount > 0 && (
                              <small style={{ color: "#2ca87f", fontSize: 11 }}>
                                You save {discountAmount.toFixed(3)} BHD
                              </small>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })()}

                  {/* Lab Test Results Section */}
                  {editLabTests.length > 0 && (
                    <div className="mt-3">
                      <div style={{ fontSize: 11, fontWeight: 700, color: "#5B6B79", textTransform: "uppercase", letterSpacing: "0.4px", marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                        <i className="ti ti-flask" style={{ color: "#4680ff" }} />
                        Lab Test Results
                      </div>
                      <div className="table-responsive">
                        <table className="table table-bordered m-0" style={{ fontSize: "12.5px" }}>
                          <thead style={{ background: "#f0f4ff" }}>
                            <tr style={{ color: "#4680ff" }}>
                              <th>Test Name</th>
                              <th style={{ width: "220px" }}>Value</th>
                              <th style={{ width: "80px" }}>Units</th>
                              <th style={{ width: "140px" }}>Range / Reference</th>
                              <th>Methodology</th>
                              <th style={{ width: "100px" }}>Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {editLabTests.map((test) => {
                              const isText = test.value_type === "text";
                              const val = editTestValues[test.id] ?? "";
                              const status = isText ? null : getTestStatus(val, test.min_range, test.max_range);
                              const bStyle = status ? statusBadgeStyle[status] : null;
                              return (
                                <tr key={test.id} style={{ background: bStyle ? bStyle.background + "22" : "transparent" }}>
                                  <td style={{ fontWeight: "500" }}>{test.test_name}</td>
                                  <td>
                                    {isText ? (
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={val}
                                        onChange={(e) => setEditTestValues((prev) => ({ ...prev, [test.id]: e.target.value }))}
                                        placeholder="e.g. Negative"
                                      />
                                    ) : (
                                      <input
                                        type="number"
                                        step="0.01"
                                        className="form-control form-control-sm"
                                        value={val}
                                        onChange={(e) => setEditTestValues((prev) => ({ ...prev, [test.id]: e.target.value }))}
                                        placeholder="—"
                                        style={{ borderColor: bStyle ? bStyle.color + "88" : undefined }}
                                      />
                                    )}
                                  </td>
                                  <td className="text-center">{test.units || "—"}</td>
                                  <td className="text-center" style={{ color: "#6c757d", fontSize: "12px" }}>
                                    {isText
                                      ? (test.reference_text || "—")
                                      : `${test.min_range !== null ? parseFloat(test.min_range).toFixed(2) : "—"} – ${test.max_range !== null ? parseFloat(test.max_range).toFixed(2) : "—"}`}
                                  </td>
                                  <td style={{ color: "#6c757d" }}>{test.methodology || "—"}</td>
                                  <td className="text-center">
                                    {status && (
                                      <span style={{ ...bStyle, borderRadius: "10px", padding: "2px 10px", fontSize: "11px", fontWeight: "600", whiteSpace: "nowrap" }}>
                                        {statusLabel[status]}
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}

                  {/* Attachments Section */}
                  <div className="mt-3">
                    <label style={labelStyle}>
                      Attachments ({editAttachments.length})
                    </label>
                    {editAttachments.length > 0 && (
                      <div className="table-responsive mb-3">
                        <table className="table table-sm table-bordered m-0" style={{ fontSize: 12.5 }}>
                          <thead style={{ background: "#f0f4ff" }}>
                            <tr style={{ color: "#4680ff" }}>
                              <th>Name</th>
                              <th>File</th>
                              <th>Uploaded At</th>
                              <th style={{ width: 60 }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {editAttachments.map((attachment) => (
                              <tr key={attachment.attachment_id}>
                                <td>{attachment.attachment_name}</td>
                                <td>
                                  {attachment.filename ? (
                                    <a
                                      href={`${baseurImage}${attachment.filename}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{ color: "#4680ff", fontWeight: 600 }}
                                    >
                                      View File
                                    </a>
                                  ) : (
                                    <span style={{ color: "#adb5bd" }}>No file</span>
                                  )}
                                </td>
                                <td>
                                  {new Date(
                                    attachment?.uploaded_at
                                  ).toLocaleDateString()}
                                </td>
                                <td className="text-center">
                                  <i
                                    className="ti ti-trash f-20"
                                    style={{ color: "#e03131", cursor: "pointer" }}
                                    onClick={() =>
                                      handleDeleteAttachment(
                                        attachment.attachment_id
                                      )
                                    }
                                  />
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    <div className="row g-3">
                      <div className="col-md-4">
                        <label style={labelStyle}>Add New Attachment</label>
                        <input
                          type="file"
                          name="newAttachment"
                          onChange={(e) => setEditData(prev => ({ ...prev, newAttachment: e.target.files[0] }))}
                          className="form-control form-control-sm"
                          style={inputStyle}
                          accept="image/*,application/pdf,.doc,.docx"
                        />
                      </div>
                      <div className="col-md-4">
                        <label style={labelStyle}>Attachment Name</label>
                        <input
                          type="text"
                          name="attachmentName"
                          value={editData.attachmentName || ""}
                          onChange={handleEditChange}
                          className="form-control form-control-sm"
                          style={inputStyle}
                          placeholder="Enter attachment name"
                        />
                      </div>
                    </div>
                    <div className="mt-2">
                      <button
                        type="button"
                        className="borderBtn"
                        style={{ fontSize: 12, padding: "5px 14px" }}
                        onClick={async () => {
                          if (!editData.newAttachment || !editData.attachmentName) {
                            Swal.fire("Error", "Please fill all attachment fields", "error");
                            return;
                          }

                          const formData = new FormData();
                          formData.append("file", editData.newAttachment);
                          formData.append("name", editData.attachmentName);

                          try {
                            const res = await axiosInstance.post(
                              `addLabRequestAttachment/${editData.request_id}`,
                              formData,
                              {
                                headers: { "Content-Type": "multipart/form-data" },
                              }
                            );
                            if (res.data.success) {
                              // Refresh attachments
                              const attachRes = await axiosInstance.get(
                                `getLabRequestAttachmentsByLabRequestId/${editData.request_id}`
                              );
                              if (attachRes.data.success) {
                                setEditAttachments(attachRes.data.data);
                              }
                              // Clear attachment fields
                              setEditData(prev => ({
                                ...prev,
                                newAttachment: null,
                                attachmentName: "",
                              }));
                              Swal.fire("Success", "Attachment added successfully", "success");
                            }
                          } catch (err) {
                            Swal.fire("Error", "Failed to upload attachment", "error");
                          }
                        }}
                        disabled={
                          !editData.newAttachment ||
                          !editData.attachmentName
                        }
                      >
                        Add Attachment
                      </button>
                    </div>
                  </div>
                </div>
                <div className="modal-footer d-flex justify-content-end" style={{ padding: "12px 20px", borderTop: "1px solid #e8ecf0", flexShrink: 0 }}>
                  <button
                    type="button"
                    className="cancelText"
                    onClick={() => setShowEditModal(false)}
                  >
                    Cancel
                  </button>
                  <button type="submit" className="bgBtn">
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}





      {showViewAttachmentsModal && (
        <div
          className="modal fade show"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "block",
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  View Attachments - {selectedLabRequest?.title}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowViewAttachmentsModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {viewAttachments.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Attachment Name</th>
                          <th>File</th>
                          <th>Status</th>
                          <th>Uploaded At</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewAttachments.map((attachment) => (
                          <tr key={attachment.attachment_id}>
                            <td>{attachment.attachment_name}</td>
                            <td>
                              {attachment.filename ? (
                                <a
                                  href={`${baseurImage}${attachment.filename}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-sm btn-outline-primary"
                                >
                                  View File
                                </a>
                              ) : (
                                "No file"
                              )}
                            </td>
                            <td>{attachment.report_status}</td>
                            <td>
                              {new Date(
                                attachment.uploaded_at
                              ).toLocaleDateString()}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => {
                                  handleDeleteAttachment(
                                    attachment.attachment_id
                                  );
                                  // Also remove from viewAttachments
                                  setViewAttachments((prev) =>
                                    prev.filter(
                                      (att) =>
                                        att.attachment_id !==
                                        attachment.attachment_id
                                    )
                                  );
                                }}
                              >
                                <i className="ti ti-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div className="alert alert-info">
                    No attachments found for this lab request.
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowViewAttachmentsModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* WhatsApp default notification template for Labs */}
      {showWhatsappModal && (
        <div
          className="modal fade show"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <div>
                  <h5 className="modal-title d-flex align-items-center gap-1">
                    <i
                      className="ti ti-brand-whatsapp"
                      style={{ color: "#25D366" }}
                    />
                    Whatsapp Notification
                  </h5>
                  <div style={{ fontSize: 11, color: "#5B6B79" }}>
                    Select the SMS template used as the default Lab
                    notification
                  </div>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowWhatsappModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {loadingSmsTemplates ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "24px 0",
                      color: "#5B6B79",
                      fontSize: 13,
                    }}
                  >
                    Loading templates...
                  </div>
                ) : smsTemplates.length === 0 ? (
                  <div className="alert alert-info mb-0">
                    No SMS templates found. Create one under Notification
                    Center &gt; SMS Templates first.
                  </div>
                ) : (
                  <div
                    style={{
                      maxHeight: 320,
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                      gap: 8,
                    }}
                  >
                    {smsTemplates.map((t, i) => {
                      const active =
                        String(selectedWhatsappTemplate) === String(t.id);
                      return (
                        <div
                          key={t.id}
                          onClick={() =>
                            setSelectedWhatsappTemplate(String(t.id))
                          }
                          style={{
                            border: `1px solid ${active ? "#25D366" : "#e8ecf0"}`,
                            background: active ? "#25D36612" : "#fff",
                            borderRadius: 8,
                            padding: "10px 12px",
                            cursor: "pointer",
                          }}
                        >
                          <div className="d-flex align-items-center gap-2">
                            <input
                              type="radio"
                              name="labWhatsappTemplate"
                              checked={active}
                              onChange={() =>
                                setSelectedWhatsappTemplate(String(t.id))
                              }
                            />
                            <div>
                              <div
                                style={{
                                  fontSize: 13,
                                  fontWeight: 600,
                                  color: "#1a202c",
                                }}
                              >
                                {t.template_name || `Template ${i + 1}`}
                              </div>
                              {t.subject && (
                                <div
                                  style={{ fontSize: 11, color: "#5B6B79" }}
                                >
                                  {t.subject}
                                </div>
                              )}
                              {t.content && (
                                <div
                                  style={{
                                    fontSize: 11,
                                    color: "#5B6B79",
                                    marginTop: 3,
                                    whiteSpace: "pre-wrap",
                                  }}
                                >
                                  {t.content}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowWhatsappModal(false)}
                  disabled={savingWhatsappTemplate}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={saveWhatsappTemplate}
                  disabled={
                    savingWhatsappTemplate ||
                    loadingSmsTemplates ||
                    !selectedWhatsappTemplate
                  }
                >
                  {savingWhatsappTemplate ? "Saving..." : "Save as Lab Default"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function TablePagination({ currentPage, totalPages, setCurrentPage }) {
  if (!totalPages || totalPages < 2) return null;
  return (
    <nav className="tablepagination d-flex justify-content-end">
      <ul className="pagination mb-0">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
          >
            &laquo;
          </button>
        </li>
        <li className="pageNmbr">{`${currentPage} of ${totalPages}`}</li>
        <li
          className={`page-item ${currentPage === totalPages ? "disabled" : ""
            }`}
        >
          <button
            className="page-link"
            onClick={() =>
              currentPage < totalPages && setCurrentPage(currentPage + 1)
            }
          >
            &raquo;
          </button>
        </li>
      </ul>
    </nav>
  );
}
